import { render, staticRenderFns } from "./SignUpTg.vue?vue&type=template&id=f75fc0d0&scoped=true&"
var script = {}
import style0 from "./SignUpTg.vue?vue&type=style&index=0&id=f75fc0d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f75fc0d0",
  null
  
)

export default component.exports